function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { useResponsive } from 'features/storefront/utils/useResponsive';
export function useStyles({ headingSize }) {
    const responsiveGrid = useResponsive({
        base: {
            gridTemplateAreas: `
      'heading'
      'carousel'
      'cta'
      `
        },
        m: {
            gridTemplateAreas: `
      '. . controls'
      'heading heading heading'
      'carousel carousel carousel'
      'cta . .'
      `,
            gridTemplateColumns: '348px auto auto'
        },
        l: {
            gridTemplateAreas: `
      '. . controls'
      'heading carousel carousel'
      'cta carousel carousel'
      '. carousel carousel'
      `,
            gridTemplateColumns: '348px auto auto'
        }
    });
    const grid = _object_spread({
        display: 'grid'
    }, responsiveGrid);
    const headingImage = {
        marginBottom: useResponsive({
            base: '0',
            m: '24px'
        })
    };
    const carousel = {
        '& > span': {
            height: '100%'
        }
    };
    const isMobile = useResponsive({
        base: true,
        m: false
    });
    const responsiveControls = useResponsive({
        base: false,
        l: true
    });
    /* ------------------------------ inline styles ------------------------------ */ const cardWidth = useResponsive({
        base: 280,
        m: 358
    });
    const headingTextSize = useResponsive({
        base: 'heading/desktop/m',
        l: headingSize === 'large' ? 'display/desktop/m' : 'heading/desktop/m'
    });
    const textSize = useResponsive({
        base: 'body/s',
        m: headingSize === 'large' ? 'body/l' : 'body/s'
    });
    const badgeWidth = useResponsive({
        base: 100,
        m: 145
    });
    return {
        css: {
            carousel,
            grid,
            headingImage
        },
        isMobile,
        inline: {
            badgeWidth,
            cardWidth,
            headingTextSize,
            textSize
        },
        responsiveControls
    };
}
